// extracted by mini-css-extract-plugin
export default {"ModalContainer":"ModalFancy_ModalContainer__Of+in"};